import RouteName from '@/models/enums/RouteName'

export default [
    {
        path: '/price-lists',
        name: RouteName.PriceLists,
        component: () => import('../../../pages/PriceLists/PriceLists.vue'),
        meta: {
          breadcrumb: {
            label: 'Прайс-листы',
            parent: RouteName.Directory,
          },
        },
      },
      {
        path: '/price-lists/create',
        name: 'price-list-create',
        component: () => import('../../../pages/PriceLists/PriceListForm.vue'),
        meta: {
          breadcrumb: {
            label: 'Новый прайс-лист',
            parent: RouteName.PriceLists,
          },
        },
      },
      {
        path: '/price-lists/:id',
        name: 'price-list-edit',
        component: () => import('../../../pages/PriceLists/PriceListForm.vue'),
        props: { isEdit: false },
        meta: {
          breadcrumb: {
            label: 'Редактирование прайс-листа',
            parent: RouteName.PriceLists,
          },
        },
      },
]
